import React, { useState } from 'react'
import { Box } from '../../../../../../../../Components/CustomUi/box'
import Input from '../../../../../../../../Components/CustomUi/input'
import { Select } from '../../../../../../../../Components/CustomUi/Select'
import {
  faCapsules,
  faCheck,
  faDroplet,
  faLeaf,
  faPen,
  faPlus,
  faWheatAlt,
} from '@fortawesome/free-solid-svg-icons'
import ButtonCustom from '../../../../../../../../Components/ButtonCustom'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { HeaderTable } from '../../../../../../../../Components/CustomUi/table/headerTable'
import { BodyTable } from '../../../../../../../../Components/CustomUi/table/bodyTable'
import { Render } from '../../../../../../../../Components/CustomUi/render'
import { RowTable } from '../../../../../../../../Components/CustomUi/table/rowTable'
import { RowItem } from '../../../../../../../../Components/CustomUi/table/rowItem'
import { DeleteButton } from '../../../../../../../../Components/CustomUi/deleteButton'
import { Empty } from 'antd'
import Carregando from '../../../../../../../../Components/CustomUi/loading'
import { ItensPerUserLogged } from '../../../../../../../../services/login/permissaoUsuarioLoado'
import icone from '../../../../../../../../assets/svg/download.svg'

interface PropsDoseCultura {
  dataCulturas: any[]
  cultura: string
  setCultura: React.Dispatch<React.SetStateAction<string>>
  setCulturaId: React.Dispatch<React.SetStateAction<number>>
  valor_dose: string
  setValor_dose: React.Dispatch<React.SetStateAction<string>>
  unidadeDose: string
  setUnidadeDose: React.Dispatch<React.SetStateAction<string>>
  setUnidadeDoseId: React.Dispatch<React.SetStateAction<number>>
  doses_culturas_adicionados: any[]
  setDoses_culturas_adicionados: React.Dispatch<React.SetStateAction<any[]>>
  dataUnidadeMedida: any[]
  adicionar_dose: Function
  remover_cultura_dose: Function
  fakeLoading: boolean
  permissions?: ItensPerUserLogged
}

export const FormDoseCultura: React.FC<PropsDoseCultura> = ({
  dataCulturas,
  cultura,
  setCultura,
  setCulturaId,
  setValor_dose,
  valor_dose,
  unidadeDose,
  setUnidadeDose,
  setUnidadeDoseId,
  dataUnidadeMedida,
  doses_culturas_adicionados,
  setDoses_culturas_adicionados,
  adicionar_dose,
  remover_cultura_dose,
  fakeLoading,
  permissions,
}) => {
  const [openCultura, setOpenCultura] = useState<boolean>(false)
  const [confirmar_exclusao, setConfirmar_exclusao] = useState<boolean>(false)
  const [id_item_atual, setId_item_atual] = useState<number>(null)
  const [nome_item_atual, setNome_item_atual] = useState<string>('')
  const [openUnidadeDose, setOpenUnidadeDose] = useState(false)
  const [updateConcentracao, setUpdateConcentracao] = useState(null)

  const handleChangeMask = (data) => {
    let area = data
    area = area.replace(/([\u0300-\u036f]|[^0-9a-zA-Z\s])/g, '')
    area = (area / 100).toFixed(2).replace('.', ',')

    setValor_dose(area)
  }

  const handleChangeMaskEditar = (data) => {
    let area = data
    area = area.replace(/([\u0300-\u036f]|[^0-9a-zA-Z\s])/g, '')
    area = (area / 100).toFixed(2).replace('.', ',')
    return area
  }

  const editarAtivo = (uid) => {
    const dados = [...doses_culturas_adicionados]
    dados.forEach((data) => {
      if (data.cod === uid) {
        data.editable = true
      } else {
        data.editable = false
      }
    })
    console.log('dados', dados)
    setDoses_culturas_adicionados(dados)
  }

  const salvarAtivo = (cod) => {
    const dados = [...doses_culturas_adicionados]
    dados.forEach((data) => {
      if (data.cod === cod) {
        data.concentracao = updateConcentracao
      }
      data.editable = false
    })

    setDoses_culturas_adicionados(dados)
  }

  const mudarConcentracao = (concen, uid) => {
    let concentracao = handleChangeMaskEditar(concen)
    const dados = [...doses_culturas_adicionados]
    let temp = []
    dados.forEach((data) => {
      if (data.cod === uid) {
        data.dose = concentracao
        setUpdateConcentracao(concentracao)
      }
      temp = [...temp, data]

      return temp
    })

    setDoses_culturas_adicionados(temp)
  }

  return (
    <div>
      <Box style={{ marginBottom: '10px' }}>
        <Select
          label='Dose padrão'
          placeholder='Selecione a dose padrão'
          value={unidadeDose}
          icon={faDroplet}
          onChange={setUnidadeDose}
          onChangeID={setUnidadeDoseId}
          open={openUnidadeDose}
          trigger={setOpenUnidadeDose}
          items={dataUnidadeMedida}
          descricaoItem={'nome'}
          idItem={'cod'}
        />
        <div style={{ display: 'flex', gap: 10 }}>
          <Select
            label='Cultura'
            placeholder='Selecione a cultura'
            icon={faWheatAlt}
            value={cultura}
            onChange={setCultura}
            onChangeID={setCulturaId}
            open={openCultura}
            trigger={setOpenCultura}
            items={dataCulturas}
            descricaoItem={'nome'}
            idItem={'cod'}
          />

          <Input
            label='Dose'
            icon={faCapsules}
            placeholder='Digite o valor da dose'
            value={valor_dose}
            onChange={(e) => handleChangeMask(e)}
          />
        </div>
        <div style={{ display: 'flex', justifyContent: 'flex-end' }}>
          <ButtonCustom onClick={adicionar_dose} icon={<FontAwesomeIcon icon={faPlus} />}>
            Adicionar
          </ButtonCustom>
        </div>
      </Box>
      <HeaderTable
        itens={[
          { valor: 'Cultura', width: 'calc(100% - 280px)' },
          { valor: 'Dose', width: '160px' },
          { valor: 'Ações', width: '115px' },
        ]}
      />

      <BodyTable
        style={{
          height: 'calc(100vh - 350px)',
          position: 'relative',
          overflowX: 'hidden',
          overflowY: 'scroll',
          marginTop: -10,
        }}
      >
        <Render condition={true}>
          {(doses_culturas_adicionados ?? []).map(
            ({ cod, uid, cod_cultura, cultura_nome, dose, editable }, index) => {
              return (
                <RowTable
                  key={cod}
                  onDoubleClick={() => {}}
                  style={{ marginTop: index === 0 ? '10px' : 0 }}
                >
                  <RowItem fontSize={13} width={'calc(100% - 275px)'}>
                    {cultura_nome}
                  </RowItem>
                  <RowItem fontSize={13} width={'160px'}>
                    {editable ? (
                      <Input
                        icon={icone}
                        placeholder={''}
                        value={String(dose)}
                        onChange={(v) => mudarConcentracao(v, cod)}
                        allowClear={false}
                        desabilitado={permissions?.acesso === 1}
                      />
                    ) : (
                      `${parseFloat(dose)?.toFixed(2)} ${unidadeDose === 'mL/ha' ? 'mL/ha' : '%'}`
                    )}
                  </RowItem>

                  <RowItem width={'115px'} gap={10}>
                    <DeleteButton
                      open={confirmar_exclusao && id_item_atual === (uid ?? cod)}
                      trigger={setConfirmar_exclusao}
                      onTrigger={() => {
                        setId_item_atual(uid ?? cod)
                        setNome_item_atual(cultura_nome)
                      }}
                      loading={fakeLoading}
                      message={`o item ${cultura_nome} será excluido!`}
                      deleteds={[cultura_nome]}
                      onDelete={() => remover_cultura_dose(uid, cod, cod_cultura)}
                      disabled={fakeLoading || permissions?.acesso === 1}
                      disabledTrigger={permissions?.exclusao === 0}
                      typeButtonTrigger='secondary'
                    />
                    <ButtonCustom
                    onClick={() => (editable ? salvarAtivo(cod) : editarAtivo(cod))}
                    icon={<FontAwesomeIcon icon={editable ? faCheck : faPen} />}
                    disabled={cod === null || permissions?.acesso === 1}
                  />
                  </RowItem>
                </RowTable>
              )
            }
          )}
        </Render>

        <Render condition={doses_culturas_adicionados.length <= 0}>
          <Empty
            image={Empty.PRESENTED_IMAGE_SIMPLE}
            description={<> Nenhum registro disponível!</>}
          />
        </Render>

        <Render condition={false}>
          <Carregando
            animation
            legenda='Carregando análises...'
            justifyContent='center'
            height={'100%'}
            size='default'
          />
        </Render>
      </BodyTable>
    </div>
  )
}
